import axios from 'axios';

export default class PetService {
  constructor() {
    this.baseUrl = document.getElementById("hdnBaseUrl").value;
  }

  getPets(data) {
    var url = this.baseUrl + `api/PetOwnerMatching`;
    return axios.post(url, data);
  }

  getServices(petId, clientPracticeId) {
    var url = this.baseUrl + `api/PetVaccineService/${petId}?practiceId=${clientPracticeId}&nid=0`;
    return axios.get(url);
  }

  getSpecies(clientPracticeId) {
    var url = this.baseUrl + `api/ClientPracticeSpecies/${clientPracticeId}`;
    return axios.get(url);
  }
}



// WEBPACK FOOTER //
// ./src/api/PetService.js